import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { assert } from '@sama/js-core';
import { keyBy } from 'lodash';

import { Tag } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { ObjectWith } from '../../../../../cross-team-shared/types/misc';
import {
  isMultipleChoiceAttribute,
  isSingleChoiceAttribute,
} from '../../../../../outputs/annotation/annotation-shared/utils/attribute-utils';
import { AttributeOption } from '../../../../../team-apis/otterdam/taxonomy';
import { AbstractAttributeInputComponent } from '../abstract-attribute-input-component';

@Component({
  selector: 'h3-choice-attribute-input',
  templateUrl: './choice-attribute-input.component.html',
  styleUrls: ['../abstract-attribute-input-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChoiceAttributeInputComponent
  extends AbstractAttributeInputComponent
  implements OnInit
{
  @Input({ required: true }) multiple!: boolean;
  @ViewChild('inputArea', { static: false }) inputArea!: MatSelect;

  options!: ObjectWith<AttributeOption>;

  override ngOnInit() {
    assert(
      isSingleChoiceAttribute(this.attribute) ||
        isMultipleChoiceAttribute(this.attribute),
      `Attribute ${this.attribute.name} is not a choice attribute.`,
    );
    this.options = keyBy(this.attribute.options, 'value');
    super.ngOnInit();
  }

  focusIn() {
    this.isFocused = true;
    setTimeout(() => {
      this.inputArea.open();
      this.inputArea.focus();
    }, 0);
  }

  focusOut(event: FocusEvent) {
    if (this.inputArea.panelOpen) {
      // We get a null relatedTarget when clicking on the backdrop of the input
      if (event.relatedTarget === null) {
        this.inputArea.focus();
        return;
      }
      const focusIsFromSelectPanel =
        this.inputArea.panel.nativeElement.contains(event.relatedTarget);
      if (!focusIsFromSelectPanel) {
        this.isFocused = false;
        return;
      }
    } else {
      this.isFocused = false;
    }
  }

  protected onSelectionChange(value: Tag) {
    this.setAttribute(value);
  }
}
